import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Blog = () => {
    const [blogs, setBlogs] = useState([]);

    // 📌 Fetch All Blogs from API
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get("https://api.irfanelectricals.com/api/blog");
                setBlogs(response.data.blogs); // ✅ Get all blogs
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        };
        fetchBlogs();
    }, []);

    return (
        <>
            <Navbar />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1 className="text-uppercase">Blog</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="#">Home</a> <span className="mx-2 text-muted">/</span> Blog
                            </h6>
                        </div>
                    </div>
                </div>
            </section>

            {/* Blog Section */}
            <section id="blog_h" className="p_3">
                <div className="container-xl">
                    <div className="row about_h1 text-center mb-4">
                        <div className="col-md-12">
                            <h4 className="col_blue">Our Blog</h4>
                            <h1 className="mt-3 mb-0">Latest Blog & Articles</h1>
                        </div>
                    </div>

                    <div className="blog_h1 row">
                        {blogs.length > 0 ? (
                            blogs.map((blog) => (
                                <div className="col-md-4 mb-4" key={blog.id}>
                                    <div className="blog_h1i">
                                        <div className="grid clearfix">
                                            <figure className="effect-jazz mb-0">
                                                <a href={`/blog/${blog.id}`}>
                                                    <img
                                                        src={`https://api.irfanelectricals.com/uploads/${blog.image}`}
                                                        alt={blog.name}
                                                        className="w-100"
                                                        style={{
                                                            width: "360px", // ✅ Fixed width
                                                            height: "280px", // ✅ Fixed height
                                                            objectFit: "cover", // ✅ Ensures proper image cropping
                                                            display: "block",
                                                            margin: "0 auto", // ✅ Centers the image
                                                        }}
                                                        onError={(e) =>
                                                            (e.target.src = "https://via.placeholder.com/360x280")
                                                        }
                                                    />
                                                </a>
                                            </figure>
                                        </div>
                                        <div className="blog_h1i1 shadow_box p-3 bg_light">
                                            <h4>
                                                <a href={`/blog/${blog.id}`}>{blog.name}</a>
                                            </h4>
                                            <p>{blog.description.substring(0, 100)}...</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center w-100">
                                <p>No blogs available.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Blog;
